export class CreateVaultResponse {
    'vault';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vault",
            "baseName": "vault",
            "type": "BackupVault",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateVaultResponse.attributeTypeMap;
    }
    constructor() {
    }
}
